import { rvh, } from "themes/constants/sizes"

export const styles = {
  main: (theme) => ({
    position: "relative",
    width: "100vw",
    minHeight: rvh(),
    top: 10,
  }),
}
